var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultCompanyLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5431_71379)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.8438,
    height: 44.8438,
    transform: "translate(-1.42188 -1.42188)",
    fill: "#E2E8EE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.7633,
    cy: 11.1344,
    r: 3.5875,
    fill: "#C1CFDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8298 16.673L-2.99219 34.902V44.7676H44.5422V28.1754L38.2976 22.1092C37.4114 21.2483 35.9958 21.2665 35.1321 22.1499L26.8289 30.6418L14.2923 16.5381C13.3535 15.4819 11.6836 15.547 10.8298 16.673Z",
    fill: "#C1CFDC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5431_71379"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.8438,
    height: 44.8438,
    fill: "white",
    transform: "translate(-1.42188 -1.42188)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultCompanyLogo);
export default __webpack_public_path__ + "static/media/DefaultCompanyLogo.82939c9828b67ee49a0c98888afd558a.svg";
export { ForwardRef as ReactComponent };